/* tslint:disable */
import { NgModule, ModuleWithProviders } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationInterface } from './api-configuration';

import { AgeRangeTypeService } from './services/age-range-type.service';
import { CartridgeTypeService } from './services/cartridge-type.service';
import { DeploymentLocationService } from './services/deployment-location.service';
import { DeploymentSearchViewService } from './services/deployment-search-view.service';
import { EmrAttachmentViewService } from './services/emr-attachment-view.service';
import { EmrMedicalRecordStatusService } from './services/emr-medical-record-status.service';
import { EmrPatientSearchViewService } from './services/emr-patient-search-view.service';
import { EmrPtrDiagnosisViewService } from './services/emr-ptr-diagnosis-view.service';
import { EmrPtrLabResultsViewService } from './services/emr-ptr-lab-results-view.service';
import { EmrPtrNoteViewService } from './services/emr-ptr-note-view.service';
import { EmrPtrOrderViewService } from './services/emr-ptr-order-view.service';
import { EmrPtrReportViewService } from './services/emr-ptr-report-view.service';
import { EmrPtrVitalsViewService } from './services/emr-ptr-vitals-view.service';
import { EmrSurveyResponseViewService } from './services/emr-survey-response-view.service';
import { EmrSurveyViewService } from './services/emr-survey-view.service';
import { EmrTriageStatusService } from './services/emr-triage-status.service';
import { FitTestService } from './services/fit-test.service';
import { FitTestDocumentService } from './services/fit-test-document.service';
import { FitTestResultService } from './services/fit-test-result.service';
import { HirAuthenticationService } from './services/hir-authentication.service';
import { HirPolicyAuthorizationService } from './services/hir-policy-authorization.service';
import { HirUserService } from './services/hir-user.service';
import { LocationPatientLogViewService } from './services/location-patient-log-view.service';
import { LocationSummaryViewService } from './services/location-summary-view.service';
import { LocationTypeService } from './services/location-type.service';
import { NonEmrPatientService } from './services/non-emr-patient.service';
import { NonEmrPatientDocumentService } from './services/non-emr-patient-document.service';
import { RecordStatusTypeService } from './services/record-status-type.service';
import { RespiratorService } from './services/respirator.service';
import { RespiratorTestService } from './services/respirator-test.service';
import { RespiratorTypeService } from './services/respirator-type.service';
import { ResponderHealthStatementService } from './services/responder-health-statement.service';
import { ResponderHealthStatementNoteService } from './services/responder-health-statement-note.service';
import { RhsDocumentService } from './services/rhs-document.service';
import { RhsReviewStatusService } from './services/rhs-review-status.service';
import { RhsReviewStatusHistoryService } from './services/rhs-review-status-history.service';
import { RhsSearchResultsViewService } from './services/rhs-search-results-view.service';

/**
 * Provider for all Api services, plus ApiConfiguration
 */
@NgModule({
  imports: [
    HttpClientModule
  ],
  exports: [
    HttpClientModule
  ],
  declarations: [],
  providers: [
    ApiConfiguration,
    AgeRangeTypeService,
    CartridgeTypeService,
    DeploymentLocationService,
    DeploymentSearchViewService,
    EmrAttachmentViewService,
    EmrMedicalRecordStatusService,
    EmrPatientSearchViewService,
    EmrPtrDiagnosisViewService,
    EmrPtrLabResultsViewService,
    EmrPtrNoteViewService,
    EmrPtrOrderViewService,
    EmrPtrReportViewService,
    EmrPtrVitalsViewService,
    EmrSurveyResponseViewService,
    EmrSurveyViewService,
    EmrTriageStatusService,
    FitTestService,
    FitTestDocumentService,
    FitTestResultService,
    HirAuthenticationService,
    HirPolicyAuthorizationService,
    HirUserService,
    LocationPatientLogViewService,
    LocationSummaryViewService,
    LocationTypeService,
    NonEmrPatientService,
    NonEmrPatientDocumentService,
    RecordStatusTypeService,
    RespiratorService,
    RespiratorTestService,
    RespiratorTypeService,
    ResponderHealthStatementService,
    ResponderHealthStatementNoteService,
    RhsDocumentService,
    RhsReviewStatusService,
    RhsReviewStatusHistoryService,
    RhsSearchResultsViewService
  ],
})
export class ApiModule {
  static forRoot(customParams: ApiConfigurationInterface): ModuleWithProviders {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: {rootUrl: customParams.rootUrl}
        }
      ]
    }
  }
}
